<template>
    <div
        :class="'d-flex flex-row flex-wrap text-left note-content pa-3 mb-4 '"
        @click="setPage">
        <div class="col-11 pa-0">
            <div class="col-12 pa-0">
                <v-chip
                    label
                    small
                    dark
                    color="#B8C0CC"
                    class="mb-1 font-weight-bold"
                    >
                    <span class="text-uppercase">{{ $t('bookReading.chapter') + ' ' + note_data.bookChapter.chapterNumber}}</span>
                     -
                    <span class="text-uppercase">{{ $t('bookReading.page') + ' ' + note_data.page}}</span>
                </v-chip>
            </div>
            <div class="col-12 pa-0">
                <p class="d-inline-block font-size-14 mb-0 line-height-130">{{ note_data.content }}</p>
            </div>
            <div class="col-12 pa-0">
                <small class="note-date">
                    {{ $t('bookReading.saved_the') }} {{ note_data.createdDate | formatDate}} hrs.
                </small>
            </div>
        </div>
        <div class="d-flex col-1 pa-0 align-center justify-end">
            <v-btn
                icon 
                small
                @mouseup.prevent="noteAction" >
                <v-img :src="trashIcon" width="32"></v-img>
            </v-btn>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import bookUserNotesService from '@/services/bookUserNotes'

export default {
    props: {
        note_data: { type: Object, default: null },
    },
    data() {
        return {
            loading: false,
            btnLoaded: false,
            trashIcon: require('@/assets/img/icons/new-reading/highlight/icon-trash.svg')
        }
    },
    computed: {
        ...mapState({
            currentStage: (state) => state.bookReading.currentStage,
            currentPage: (state) => state.bookReading.currentPage,
            currentChapter: (state) => state.bookReading.currentChapter,
            currentChapterData: (state) => state.bookReading.currentChapterData,
            bookUserNotes: (state) => state.bookReading.bookUserNotes,
        }),
    },
    methods: {
        ...mapActions('bookReading', [
            'setCurrentPage',
            'setCurrentChapter',
            'setCurrentChapterData',
            'hideAllUtils',
            'setBookUserNotes',
        ]),
        setPage() {
            window.scrollTo(0, 0)
            let chapterHtml = document.querySelector(`#chapter_${this.currentChapter}`)
            if (chapterHtml) chapterHtml.style.display = 'none'

            let bookPage = document.querySelector(`#bookpage_${this.currentPage}`)
            if (bookPage) bookPage.style.display = 'none'

            this.setCurrentChapter(this.note_data.bookChapter.chapterNumber)
            this.setCurrentPage(this.note_data.page)

            chapterHtml = document.querySelector(`#chapter_${this.currentChapter}`)
            if (chapterHtml) chapterHtml.style.display = 'block'

            const currentPage = document.querySelector(`.current-page`)
            if(currentPage) currentPage.classList.toggle('current-page')

            bookPage = document.querySelector(`#bookpage_${this.currentPage}`)
            if (bookPage) {
                bookPage.style.display = 'flex'
                bookPage.classList.toggle('current-page')
            }

            this.setCurrentChapterData(this.note_data.bookChapter)
            this.hideAllUtils()
        },
        async noteAction(){
            await bookUserNotesService
                .deleteNote(this.note_data.id)
                .then((response) => {
                    this.setBookUserNotes(response.content)
                })
                .catch((error) => console.error(error))
            this.btnLoaded = !this.btnLoaded
        }
    },
    filters: {
        // Dar formato a la fecha de creación de la nota
        formatDate(timestamp) {
            const date = new Date(timestamp);
            const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
            const formattedDate = date.toLocaleString('es-ES', options);
            return formattedDate;
        }
    }
}
</script>

<style lang="scss" scoped>
.note-content:hover {
    cursor: pointer;
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)) !important;
    border-radius: 2px;
}
.note-content {
    /* border: 1.5px solid #514773 !important; */
    border-radius: 6px;
    background: #F0F2F4;
    color: #323A46;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)) !important;
    transition: background-image 0.5s ease;
}
.note-date{
    color: #64748B;
}
.chapter-active {
    border: 1.5px solid #514773 !important;
    background: #514773 !important;
    color: white !important;
}
</style>
